/*
 * modal
 */


import MicroModal from 'micromodal';
import Pikaday from 'pikaday';

const modal = {
    cfg:  {
        name: 'modal'
    },

    log(msg) {
        // console.log(msg);
    },

    init() {
        /* eslint-disable */
        window.addEventListener('load', () => {
            MicroModal.init({
                disableScroll: false,
            });




            const inputs = [...document.querySelectorAll('[class*="js-date"]')];
            if (inputs) {
                inputs.forEach((input) => {
                    let picker = new Pikaday({
                        field: input,
                        format: 'D.M.YYYY',
                        firstDay: 1,
                        minDate: new Date(),
                        i18n: {
                            previousMonth : 'Vorheriger Monat',
                            nextMonth     : 'Nächster Monat',
                            months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                            weekdays      : ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
                            weekdaysShort : ['So','Mo','Di','Mit','Do','Fr','Sa']
                        }
                    });
                });
            }
        });
        /* eslint-enable */
    }
};

export default modal;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/bookingForm/_script.js